import createSolidComponent from '../createSolidComponent';
export default createSolidComponent('outline', 'selector', 'Selector', [["path",{"d":"M8 9l4 -4l4 4"}],["path",{"d":"M16 15l-4 4l-4 -4"}]]);